<template>
  <div class="iframe-container">
    <iframe
      ref="alisonIframe"
      src="https://homo.certisur.net/alison-sdk/test-panel/"
      allow="local-network-access *"
      class="alison-iframe"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'AlisonIframe',
  data() {
    return {
      iframeUrl: '',
      isReady: false
    };
  },
  props: {
    initialParams: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.initializeIframe();
  },
  watch: {
    // Reconstruir cuando cambian los params
    initialParams: {
      handler() { this.$nextTick(this.initializeIframe); },
      deep: true
    }
  },
  methods: {
    initializeIframe() {
      this.iframeUrl = 'https://homo.certisur.net/alison-sdk/test-panel/';
    },
    onIframeLoad() {
      this.isReady = true;
      this.$emit('loaded');
    },
    // Method to send data to the iframe
    sendToIframe(data) {
      if (this.isReady) {
        this.$refs.alisonIframe.contentWindow.postMessage(data, '*');
      }
    }
  },
  beforeUnmount() {
    // Nada que limpiar: usamos página estática
  }
};
</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100%;
}

.alison-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}
</style>
